import { Component } from 'react'
import Translation from '../../Translation/cont/Translation'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import PresetPreview from '../../PageSocialMediaPreset/present/PresetPreview'
import config from '../../../config.json'

const PREVIEW_FORMAT = { width: 1080, height: 1350 }
const PREVIEW_CANVAS_W = 600
const PREVIEW_CARD_W   = 110
const PREVIEW_SCALE    = PREVIEW_CARD_W / PREVIEW_CANVAS_W
const PREVIEW_CARD_H   = Math.round(PREVIEW_CARD_W * PREVIEW_FORMAT.height / PREVIEW_FORMAT.width)

class PageSocialMedia extends Component {
    render() {
        const { presets, isLoading, onCreateNew, onEdit, onDuplicate, onDelete, onGeneratePost } = this.props
        return (
            <WrapperPageSimple pageTitleTransId={config.routes.socialMedia.transId} pageTitle={config.routes.socialMedia.name}>
            <div className="page-social-media site-content">
                <div className="type-link-wrapper">

                    <div className="type-link-item type-link-item--add" onClick={onCreateNew}>
                        <div className="type-link-preview">
                            <div className="type-link-add-icon">+</div>
                        </div>
                        <div className="type-link-name-bar">
                            <span className="type-link-add-name text-small-bold"><Translation id="social_media_add_preset" /></span>
                        </div>
                    </div>

                    {!isLoading && presets && presets.map(preset => (
                        <div key={preset.id} className="type-link-item preset-card">
                            <div className="type-link-preview preset-card__preview">
                                <div style={{
                                    width:    PREVIEW_CARD_W,
                                    height:   PREVIEW_CARD_H,
                                    overflow: 'hidden',
                                    position: 'relative',
                                    flexShrink: 0,
                                }}>
                                    <div style={{
                                        transform:       `scale(${PREVIEW_SCALE})`,
                                        transformOrigin: 'top left',
                                        width:           PREVIEW_CANVAS_W,
                                        position:        'absolute',
                                        top:             0,
                                        left:            0,
                                        pointerEvents:   'none',
                                    }}>
                                        <PresetPreview settings={preset.settings} format={PREVIEW_FORMAT} />
                                    </div>
                                </div>
                            </div>

                            <div className="preset-card__buttons">
                                <button
                                    className="btn btn-primary"
                                    onClick={() => onGeneratePost(preset.id)}>
                                    <Translation id="social_media_generate_post" />
                                </button>
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => onEdit(preset.id)}>
                                    <Translation id="edit_button" />
                                </button>
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => onDuplicate(preset)}>
                                    <Translation id="duplicate_button" />
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => onDelete(preset.id)}>
                                    <Translation id="delete_button" />
                                </button>
                            </div>

                            <div className="type-link-name-bar">
                                <span className="type-link-name text-small-bold">{preset.name}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            </WrapperPageSimple>
        )
    }
}

export default PageSocialMedia
